// extracted by mini-css-extract-plugin
export default {"inputAutocomplete":"ReopenCaseDialog_inputAutocomplete__q0RkM","selectBedLabel":"ReopenCaseDialog_selectBedLabel__mpVa4"};